// extracted by mini-css-extract-plugin
export var exit = "_0-3";
export var notificationContainer = "_0-1";
export var notificationStack = "_0-0";
export var shrinkFadeOut = "_0-4";
export var slideInUp = "_0-2";